import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import Logo from "./Logo";

export default function Footer() {
  const { t, lang } = useI18n();
  const whyLabel = lang === "en" ? "Why CAFÉ-SPOT?" : "Pourquoi CAFÉ-SPOT ?";
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 mt-32 bg-[#0A0908]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <Logo size={48} variant="mark" />
            <div className="font-serif text-[#F5F0EB] text-3xl tracking-[0.18em]">
              <span className="text-[#C5A059]">CAFÉ-</span>SPOT
            </div>
          </div>
          <div className="text-[10px] tracking-[0.35em] text-[#C5A059] uppercase mb-4">Découvrez · Dégustez · Connectez</div>
          <p className="text-[#A8A39D] text-sm max-w-sm leading-relaxed">{t("footer.tagline")}</p>
          <div className="mt-6 gold-line" />
        </div>
        <div>
          <div className="overline mb-4">Légal</div>
          <ul className="space-y-2 text-sm text-[#A8A39D]">
            <li><Link to="/legal/confidentialite" className="hover:text-[#F5F0EB] transition-colors">Confidentialité</Link></li>
            <li><Link to="/legal/conditions" className="hover:text-[#F5F0EB] transition-colors">Conditions</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-[#F5F0EB] transition-colors">Cookies</Link></li>
            <li><Link to="/legal/facturation" className="hover:text-[#F5F0EB] transition-colors">Facturation</Link></li>
            <li><Link to="/faq" className="hover:text-[#F5F0EB] transition-colors">FAQ</Link></li>
            <li><Link to="/pourquoi" className="hover:text-[#F5F0EB] transition-colors" data-testid="footer-why-link">{whyLabel}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-4">{t("footer.contact")}</div>
          <ul className="space-y-2 text-sm text-[#A8A39D]">
            <li><a href="mailto:support@cafe-spot.ca" className="hover:text-[#F5F0EB] transition-colors" data-testid="footer-email-support">support@cafe-spot.ca</a></li>
            <li><a href="mailto:business@cafe-spot.ca" className="hover:text-[#F5F0EB] transition-colors" data-testid="footer-email-business">business@cafe-spot.ca</a></li>
            <li>{t("footer.region")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-2">
          <div className="text-xs text-[#A8A39D] tracking-wider">© 2026 CAFÉ-SPOT — Tous droits réservés · {t("footer.region")}</div>
          <div className="text-xs text-[#A8A39D] tracking-[0.3em] uppercase">Fait au Québec</div>
        </div>
      </div>
    </footer>
  );
}
